// extracted by mini-css-extract-plugin
export default {"subHeader":"PaymentThreshold_subHeader__Qz1X+","amountColumn":"PaymentThreshold_amountColumn__EyOMJ"};